'use strict'

// External dependencies
import * as angular from 'angular'
import animate from 'angular-animate'
import aria from 'angular-aria'
import cookie from 'angular-cookies'
import ngFileSaver from 'angular-file-saver'
import ngLocale from 'angular-i18n/de'
import 'angular-material'
import 'angular-material-expansion-panel'
import messages from 'angular-messages'
import uiRouter from 'angular-ui-router'
import 'ng-resize/dist/ng-resize'
import ngmap from 'ngmap'
import 'ngstorage'

// Create the angular module.
// Since it is exported, other parts of the application (in other files) can then import it and register things.
// In bootstrap.js, the module is imported, and the components, services, and states are registered.

// @ngInject
export const ngmodule = angular.module('umsema-web', [
  uiRouter,
  'ngStorage',
  ngFileSaver,
  'ngMaterial',
  'material.components.expansionPanels',
  'ngResize',
  animate,
  aria,
  messages,
  ngmap,
  cookie,
  ngLocale,
])

const BLANK_MODULE = {
  states: [],
  components: {},
  directives: {},
  services: {},
  factories: {},
  providers: {},
  filters: {},
  configBlocks: [],
  runBlocks: [],
}

/**
 * Register each app module's states, directives, components, filters, services,
 * and config/run blocks with the `ngmodule`
 *
 * @param ngModule the `angular.module()` object
 * @param appModule the feature module consisting of components, states, services, etc
 */

// @ngInject
export function loadNg1Module(ngModule, appModule) {
  let module = Object.assign({}, BLANK_MODULE, appModule)

  ngModule.config(['$stateProvider', ($stateProvider) => module.states.forEach((state) => $stateProvider.state(state))])

  Object.keys(module.components).forEach((name) => ngModule.component(name, module.components[name]))
  Object.keys(module.directives).forEach((name) => ngModule.directive(name, module.directives[name]))
  Object.keys(module.services).forEach((name) => ngModule.service(name, module.services[name]))
  Object.keys(module.filters).forEach((name) => ngModule.filter(name, module.filters[name]))
  Object.keys(module.providers).forEach((name) => ngModule.provider(name, module.providers[name]))
  Object.keys(module.factories).forEach((name) => ngModule.factory(name, module.factories[name].factory))

  module.configBlocks.forEach((configBlock) => ngModule.config(configBlock))
  module.runBlocks.forEach((runBlock) => ngModule.run(runBlock))

  return ngModule
}



// WEBPACK FOOTER //
// ./bootstrap/ngmodule.js